module.exports = __webpack_public_path__ + "img/screwdriver.0bb81842.svg";